import { HandleList } from "features/option-controls/handle-option-controls/HandleList";
import { SlidesLayout } from "./SlidesLayout";

export const HandleSelector = () => {
  return (
    <SlidesLayout>
      <div className="gg-grid gg-w-full gg-grid-cols-2 gg-place-items-center gg-items-start gg-gap-y-3">
        <HandleList />
      </div>
    </SlidesLayout>
  );
};
